import { ChartAxis, ChartSerie } from "./common-chart";

export class MultiChartDatasource {
  zoomInfo: any;
  title: string;
  series: ChartSerie[];
  axisX: ChartAxis;
  axisY: ChartAxis;
  xValues: number[];
  xLabels: string[];
  secondAxisY: boolean;
  secondAxisYFree: boolean;
  secondAxisYIsPercentage: boolean;
  secondAxisYMultiplyBy100: boolean;
  secondAxisYUnit: string;
  secondAxisYMaxFree: boolean;
  secondAxisYMinFree: boolean;
}
